type PendingReviewSubmittedDocumentIconProps = {
  className?: string;
};

/** Document with approve / reject badges — pending-review task row icon. */
export const PendingReviewSubmittedDocumentIcon = ({
  className = 'h-10 w-10',
}: PendingReviewSubmittedDocumentIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    className={className}
    aria-hidden
  >
    <path d="M22 2H8c-1.1 0-2 .9-2 2v24c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6l-4-4z" fill="#ECEFF1" />
    <path d="M22 2v4h4" fill="none" stroke="#CFD8DC" strokeWidth="1.5" />
    <line x1="10" y1="10" x2="18" y2="10" stroke="#B0BEC5" strokeWidth="2" strokeLinecap="round" />
    <line x1="10" y1="15" x2="22" y2="15" stroke="#B0BEC5" strokeWidth="2" strokeLinecap="round" />
    <line x1="10" y1="20" x2="14" y2="20" stroke="#B0BEC5" strokeWidth="2" strokeLinecap="round" />
    <g transform="translate(0, 2)">
      <circle cx="11" cy="25" r="4.5" fill="#5D4037" />
      <path
        d="M9.5 23.5l3 3M12.5 23.5l-3 3"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g transform="translate(0, 2)">
      <circle cx="21" cy="25" r="4.5" fill="#5D4037" />
      <path
        d="M19 25l1.5 1.5 2.5-2.5"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
